import { useQuery } from 'providers/tanstack-query/useQuery'
import { GET_FILTERING_RULE } from './api/query'
import { Data, Variables } from './api/types'
import { FilteringRuleSlice, UseGetFilteringRule, UseGetFilteringRuleProps } from './types'

export const useGetFilteringRule = ({ id }: UseGetFilteringRuleProps): UseGetFilteringRule => {
  const { data } = useQuery<Variables, Data, FilteringRuleSlice>({
    options: {
      enabled: id !== undefined,
      select: ({ node }: Data): FilteringRuleSlice | undefined => node ?? undefined,
    },
    query: GET_FILTERING_RULE,
    variables: {
      id: id!,
    },
  })

  return { filteringRule: data }
}
